<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <GroupForm :baseGroup="group" :loading="loading" @submit-requested="submitRequested"></GroupForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import GroupForm from './GroupForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            group: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { GroupForm },
    computed:
    {
        ...mapState('groups', ['getGroupByIdOutput']),
    },
    methods: {
        ...mapActions('groups', ['getGroupById']),
        ...mapActions('groups', ['putGroup']),
        submitRequested(groups) {
            this.putGroup(groups);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'GroupsList' });
        }

        this.getGroupById(this.$route.query.id);
    },
    watch:
    {
        getGroupByIdOutput: function(groupOutput)
        {
            if(!groupOutput && !groupOutput.data)
            {
                router.push({ name: 'GroupsList' });
            }
            else
            {
                this.group = groupOutput.data;
                // console.log(this.group);
                this.loading = false;
            }
        }
    }
}
</script>